import { SortDirection } from '@common/model/sortable';
import { CatalogSortingTypes } from 'src/entities/catalog/model/types';
import { catalogSortingValues } from '../const';
import { SortingInterface } from '../types';

export const getCatalogSortingType = (name: string, direction: SortDirection): CatalogSortingTypes | null => {
  const entries = Object.entries(catalogSortingValues) as [CatalogSortingTypes, SortingInterface | null][];

  for (const [key, value] of entries) {
    if (value && value.name === name && value.direction === direction) {
      return key;
    }
  }

  return null;
};
